import { getOrderedColor } from './getOrderedColor';

type Arguments = {
  donutGraph: d3.Selection<null, unknown, null, undefined>;
  pieData: d3.PieArcDatum<[string, number]>[];
  datum: d3.Arc<unknown, d3.PieArcDatum<[string, number]>>;
  pointerEvents?: string;
  colors?: string[];
  onClick?: (d: d3.PieArcDatum<[string, number]>) => void;
  setHighlightedSegment: (
    value: React.SetStateAction<string | undefined>,
  ) => void;
  setHoverSegment?: (value: React.SetStateAction<string | undefined>) => void;
  opacityFunction: (segment: string) => number;
};

export const appendDonutGraph = ({
  donutGraph,
  pieData,
  colors,
  datum,
  pointerEvents = 'all',
  onClick,
  setHighlightedSegment,
  setHoverSegment,
  opacityFunction,
}: Arguments) => {
  let timer: NodeJS.Timeout | undefined;

  donutGraph
    .selectAll('*')
    .data(pieData)
    .join('path')
    .attr('d', datum)
    .attr('fill', (datum) =>
      colors ? colors[datum.index] : getOrderedColor(datum.index),
    )
    .style('opacity', (datum) => opacityFunction(datum.data[0]))
    .style('pointer-events', pointerEvents)
    .style('cursor', 'pointer')
    .attr('stroke', 'white')
    .style('stroke-width', '1px')
    .on('click', (_e, datum) => {
      setHighlightedSegment(datum.data[0]);
      if (onClick) {
        onClick(datum);
      }
    })
    .on('mouseover', (_e, datum) => {
      if (setHoverSegment) {
        if (timer !== undefined) {
          clearTimeout(timer);
          timer = undefined;
        }
        setHoverSegment(datum.data[0]);
      }
    });

  donutGraph.on('mouseout', () => {
    if (setHoverSegment) {
      timer = setTimeout(() => {
        setHoverSegment(undefined);
      }, 20);
    }
  });
};

type EmptyDonutArguments = Pick<
  Arguments,
  'donutGraph' | 'pieData' | 'datum' | 'pointerEvents'
> & {
  fillColor: string;
};

export const appendEmptyDonutGraph = ({
  donutGraph,
  pieData,
  datum,
  pointerEvents = 'none',
  fillColor,
}: EmptyDonutArguments) => {
  donutGraph
    .selectAll('*')
    .data(pieData)
    .join('path')
    .attr('d', datum)
    .attr('fill', () => fillColor)
    .style('pointer-events', pointerEvents)
    .style('cursor', 'pointer')
    .attr('stroke', 'white')
    .style('stroke-width', '1px');
};
